import { TextInput, type TextInputProps } from "@mantine/core";
import React from "react";

const formatForDisplay = (storedValue: string = "") => {
  // Takes "YYYY-MM-DD" and returns "YYYY / MM / DD" for display
  const digits = storedValue.replace(/\D/g, "");
  const year = digits.slice(0, 4);
  const month = digits.slice(4, 6);
  const day = digits.slice(6, 8);

  if (digits.length > 6) {
    return `${year} / ${month} / ${day}`;
  }
  if (digits.length > 4) {
    return `${year} / ${month}`;
  }
  return year;
};

export function BirthdayInput(
  props: TextInputProps & {
    value?: string; // Expects "YYYY-MM-DD" from the form
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  }
) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // User is typing into the displayed format "YYYY / MM / DD"
    const rawInput = event.currentTarget.value;
    const digits = rawInput.replace(/\D/g, "").slice(0, 8);

    // Build the value to store: "YYYY-MM-DD"
    const parts = [];
    if (digits.length > 0) parts.push(digits.slice(0, 4));
    if (digits.length > 4) parts.push(digits.slice(4, 6));
    if (digits.length > 6) parts.push(digits.slice(6, 8));
    const storedValue = parts.join("-");

    // Create a synthetic event to pass the correct value to the form
    const syntheticEvent = { ...event };
    syntheticEvent.currentTarget.value = storedValue;
    props.onChange(syntheticEvent);
  };

  // The `props.value` is the stored "YYYY-MM-DD". We format it for display.
  const displayValue = formatForDisplay(props.value);

  return (
    <TextInput
      {...props}
      placeholder="YYYY / MM / DD"
      maxLength={14} // "YYYY / MM / DD".length
      onChange={handleChange}
      value={displayValue}
      inputMode="numeric"
    />
  );
}
